import { AutoComplete } from "antd";
import useHttp from "../../../hooks/use-http";
import { useState, useEffect } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import moment from "moment";

const formatNumber = (num) => {
  if (num === null || num === undefined || num === "") return "0.00";

  const number = Number(num);
  if (isNaN(number)) return num;

  return number.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const HarvestDetailsForm = (props) => {
  const [entryLatLong, setEntryLatLong] = useState({
    latitude: "6.6114656",
    longitude: "3.3587813",
  });

  const attachmentFolder = localStorage.getItem("attachmentFolder");

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude || "6.6114656";
        const longitude = position.coords.longitude || "3.3587813";

        // setEntryLatLong({ latitude, longitude });

        setEntryLatLong({ latitude: "6.6114656", longitude: "3.3587813" });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);

    return uniqueID.toString();
  }
  const [harvstDate, setHarvstDate] = useState("");


  const [ownershipType, setOwnershipType] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [tripId, setTripId] = useState("");
  const [averageEmptyCratesWeightInKg, setAverageEmptyCratesWeightInKg] =
    useState(0);
  const [loadedVehicleWeightTons, setLoadedVehicleWeightTons] = useState(0);
  const [emptyVehicleWeightTons, setEmptyVehicleWeightTons] = useState(0);

  const [vehicleData, setVehicleData] = useState([]);
  const [filterdVehicleData, setFilterdVehicleData] = useState([]);
  const [farmersOptions, setFarmersOptions] = useState([]);
  const [filteredFarmers, setFilteredFarmers] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [selectedCrop, setSelectedCrop] = useState("");
  const [harvestOfficerData, setHarvestOfficerData] = useState([]);
  const [officerId, setOfficerId] = useState("");

  const [addFarmerShare, setAddFarmerShare] = useState(false);

  const [attachments, setAttachments] = useState([]);

  const handleFileChange = (e) => {
    // const files = Array.from(e.target.files);
    // if (files.length > 0) {
    //   setAttachments((prev) => [...prev, ...files]);
    // }

    const files = e.target.files;
    const attachmentFolder = localStorage.getItem("attachmentFolder");

    const picDataArray = Array.from(files).map((file) => {
      const uniqueFilename = `${new Date().valueOf()}/${file.name}`;
      const picData = new FormData();
      picData.append("fileUpload", file, uniqueFilename);
      return picData;
    });

    const uploadedFilesData = [];

    Promise.all(
      picDataArray.map((picData) =>
        fetch(
          `${process.env.REACT_APP_BASE_URL
          }/api/file/${attachmentFolder}/harvest/${new Date().valueOf()}}`,
          {
            method: "POST",
            body: picData,
          }
        )
          .then((res) => res.json())
          .then((data) => {
            uploadedFilesData.push(data.url);
          })
      )
    )
      .then(() => {
        setAttachments([...attachments, ...uploadedFilesData]);
      })
      .catch((err) => console.error(err));
  };

  const handleRemoveFile = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const [plotOptions, setPlotOptions] = useState([]);
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    farmerId: "",
    farmerName: "",
    plotCode: "",
    cropName: "",
    varietyName: "",
    fruitQuality: "",
    crates: 0,
    extraQty: 0,
    avgWeight: 0,
    totalQty: 0,
    farmerCrates: 0,
    farmerAvgWeight: 0,
    farmerTotalQty: 0,
    farmerExtraQty: 0,
    grandTotalQty: 0,
    isFarmershare: false,
  });
  const [tableData, setTableData] = useState([]);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (e.target.type === "number" && parseFloat(value) < 0) return; // Prevent negative input
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const crates = parseFloat(formData.crates) || 0;
    const avgWeight = parseFloat(formData.avgWeight) || 0;
    const extraCrates = parseFloat(formData.extraQty) || 0;
    const totalQty = crates * avgWeight + extraCrates;

    const farmerCrates = parseFloat(formData.farmerCrates) || 0;
    const farmerAvgWeight = parseFloat(formData.farmerAvgWeight) || 0;
    const farmerExtraCrates = parseFloat(formData.farmerExtraQty) || 0;
    const farmerTotalQty = addFarmerShare
      ? farmerCrates * farmerAvgWeight + farmerExtraCrates
      : 0;

    const grandTotalQty = totalQty + farmerTotalQty;

    setFormData((prev) => ({
      ...prev,
      totalQty,
      farmerTotalQty,
      grandTotalQty,
    }));
  }, [
    formData.crates,
    formData.avgWeight,
    formData.extraQty,
    formData.farmerCrates,
    formData.farmerAvgWeight,
    formData.farmerExtraQty,
    addFarmerShare,
  ]);

  const handleAdd = () => {
    const {
      farmerId,
      farmerName,
      plotCode,
      plotName,
      cropId,
      cropName,
      varietyName,
      fruitQuality,
      crates,
      avgWeight,
      totalQty,
      farmerCrates,
      farmerAvgWeight,
      farmerTotalQty,
      farmerExtraQty,
      grandTotalQty,
      isFarmershare,
    } = formData;

    setSelectedCrop(cropName);

    // if (
    //   !inputValue ||
    //   !plotCode ||
    //   !fruitQuality ||
    //   !crates ||
    //   !avgWeight ||
    //   !totalQty
    // ) {
    //   toast.warn("Please fill all fields");
    //   return;
    // }

    if (!inputValue) {
      toast.error("Please Select Farmer");
      return;
    }
    if (!plotCode) {
      toast.error("Please Select Plot");
      return;
    }
    if (!fruitQuality) {
      toast.error("Please Select fruit quality");
      return;
    }
    if (!crates) {
      toast.error("Please  fill Crates/Bags Qty Loaded");
      return;
    }
    if (!avgWeight) {
      toast.error("Please fill Average Weight of Crate/Bags (kg)");
      return;
    }

    console.log(formData);

    if (!formData.cropName || !formData.farmerName) {
      toast.error("Please select a farmer and crop before adding.");
      return;
    }

    // Validation: Ensure same crop type for all rows
    // if (tableData.length > 0) {
    //   const firstCrop = tableData[0].cropName?.toLowerCase();
    //   const newCrop = formData.cropName?.toLowerCase();

    //   // Only allow same crop type
    //   if (firstCrop !== newCrop) {
    //     toast.error(
    //       `You can only add rows for the same crop (${tableData[0].cropName}).`
    //     );
    //     return;
    //   }
    // }

    // const existingEntry = tableData?.find(
    //   (row) =>
    //     row.farmerId == farmerId &&
    //     row.cropId == cropId &&
    //     row.fruitQuality == fruitQuality
    // );

    // if (existingEntry) {
    //   toast.error(
    //     `${inputValue} already has a ${fruitQuality} entry for ${cropName}.`
    //   );

    //   return;
    // }

    const newEntry = {
      vehicleWeighBridgeFarmerId: Date.now(),
      farmerId: formData.farmerId,
      farmerName: inputValue,
      plotCode: formData.plotCode,
      plotName: formData.plotName,
      cropName: formData.cropName,
      cropId: formData.cropId || "",
      varietyName: formData.varietyName,
      harvestId: formData.harvestId || 0,
      fruitQuality: formData.fruitQuality,
      cratesBagQtyLoaded: formData.crates,
      averageWeightOfCratesInKg: formData.avgWeight,
      extraQty: formData.extraQty || 0,
      totalQuantity: formData.totalQty || 0,

      isFarmershare: addFarmerShare,
      farmerShareCratesBagQtyLoaded: formData.farmerCrates || 0,
      farmerShareAverageWeightOfCratesInKg: formData.farmerAvgWeight || 0,
      farmerShareTotalQuantity: formData.farmerTotalQty || 0,
      farmerShareExtraQty: formData.farmerExtraQty || 0,
      grandTotal: formData.grandTotalQty || 0,
      status: 1,
    };

    console.log(newEntry);

    setTableData([...tableData, newEntry]);

    // reset
    setFormData({
      farmerId: "",
      farmerName: "",
      plotCode: "",
      plotName: "",
      cropName: "",
      cropId: "",
      varietyName: "",
      fruitQuality: "",
      harvestId: 0,
      crates: 0,
      avgWeight: 0,
      extraQty: 0,
      totalQty: 0,
      farmerCrates: 0,
      farmerExtraQty: 0,
      farmerAvgWeight: 0,
      farmerTotalQty: 0,
      isFarmershare: false,
      grandTotalQty: 0,
    });
    setInputValue("");
    setPlotOptions([]);
    setAddFarmerShare(false);
  };

  const handleDelete = (index) => {
    const updated = tableData?.filter((_, i) => i !== index);
    setTableData(updated);
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "900px",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const { sendRequest: fetchFarmersList } = useHttp();

  useEffect(() => {
    fetchFarmersList(
      {
        url: `/api/farmerDetailList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res && Array.isArray(res)) {
          const options = res?.map((farmer) => ({
            value: farmer.farmerId, // actual ID
            label: farmer.farmerName, // displayed name
          }));
          setFarmersOptions(options);
          setFilteredFarmers(options);
        }
      }
    );
  }, [fetchFarmersList]);

  const handleSearch = (val) => {
    setInputValue(val); // show typed value
    if (!val) {
      setFilteredFarmers(farmersOptions);
      return;
    }
    setFilteredFarmers(
      farmersOptions.filter((f) =>
        f.label.toLowerCase().includes(val.toLowerCase())
      )
    );

    setPlotOptions([]);
  };

  const handleSelect = (value, option) => {
    setFormData((prev) => ({
      ...prev,
      farmerId: value,
    }));
    setInputValue(option.label);
    setFormData((prev) => ({
      ...prev,
      farmerId: value,
      farmerName: option.label,
      plotCode: "",
      plotName: "",
      cropName: "",
      cropId: "",
      varietyName: "",
    }));
  };

  const { sendRequest: getVmeRegistration } = useHttp();

  const getVehicleData = () => {
    getVmeRegistration(
      {
        url: `/api/vehicleMachineEquipRegistratn/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setVehicleData(res);
        }
      }
    );
  };

  const { sendRequest: getHarvestOfficer } = useHttp();

  const getHarvestOfficerData = () => {
    getHarvestOfficer(
      {
        url: `/api/getHarvestOfficer/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setHarvestOfficerData(res);
        }
      }
    );
  };

  const { sendRequest: fetchPlotDetails } = useHttp();
  useEffect(() => {
    if (!formData.farmerId) return;

    fetchPlotDetails(
      {
        url: `/api/getfarmerPlotDetail?farmerId=${formData.farmerId}`,
      },
      (res) => {
        if (res.output && Array.isArray(res.output)) {
          const plots = res.output?.map((plot) => ({
            value: plot.plotId,
            label: plot.plotName || plot.plotCode,
          }));
          setPlotOptions(plots);
        } else {
          setPlotOptions([]);
        }
      }
    );
  }, [formData.farmerId, fetchPlotDetails]);

  const { sendRequest: fetchCropDetails } = useHttp();

  // const handlePlotChange = (e) => {
  //   const plotId = e.target.value;
  //   const plotLabel = e.target.options[e.target.selectedIndex].text;
  //   setSelectedCrop(plotLabel);

  //   setFormData((prev) => ({
  //     ...prev,
  //     plotCode: plotId,
  //     plotName: plotLabel,
  //     cropName: "",
  //     cropId: "",
  //     varietyName: "",
  //   }));

  //   if (plotId) {
  //     fetchCropDetails(
  //       {
  //         url: `/api/getfarmerCropPlotDetail?plotId=${plotId}`,
  //       },
  //       (res) => {
  //         if (res?.output && res?.output.length > 0) {
  //           const crop = res?.output[0];
  //           setFormData((prev) => ({
  //             ...prev,
  //             cropName: crop.cropName || "",
  //             varietyName: crop.cropVariety || "",
  //             cropId: crop.cropId || "",
  //           }));
  //         }
  //       }
  //     );
  //   }
  // };

  const handlePlotChange = (e) => {
    const plotId = e.target.value;
    const plotLabel = e.target.options[e.target.selectedIndex].text;

    setSelectedCrop(plotLabel);

    setFormData({
      ...formData,
      fruitQuality: "",
      harvestId: 0,
      crates: 0,
      avgWeight: 0,
      extraQty: 0,
      totalQty: 0,
      farmerCrates: 0,
      farmerExtraQty: 0,
      farmerAvgWeight: 0,
      farmerTotalQty: 0,
      isFarmershare: false,
      grandTotalQty: 0,
    });

    if (!plotId) return;

    fetchCropDetails(
      { url: `/api/getfarmerCropPlotDetail?plotId=${plotId}` },
      (res) => {
        if (res?.output && res?.output.length > 0) {
          const crop = res.output[0];
          const selectedCropName = crop.cropName?.toLowerCase();

          // Validation: enforce crop consistency
          if (tableData?.length > 0) {
            const existingCrop = tableData[0].cropName?.toLowerCase();

            const isTomatoGroup = existingCrop === "tomato";
            const isMaizeSoyGroup = ["maize", "soyabean", "soybean"].includes(
              existingCrop
            );

            const isValidTomato =
              isTomatoGroup && selectedCropName === "tomato";
            const isValidMaizeSoy =
              isMaizeSoyGroup &&
              ["maize", "soyabean", "soybean"].includes(selectedCropName);

            const isValid =
              isValidTomato ||
              isValidMaizeSoy ||
              existingCrop === selectedCropName;

            if (!isValid) {
              toast.error(
                `You can only add plots with crop ${isTomatoGroup
                  ? "Tomato"
                  : isMaizeSoyGroup
                    ? "Maize or Soyabean or Soybean"
                    : existingCrop
                }.`
              );
              return;
            }
          }

          // If validation passes, set crop data
          setFormData((prev) => ({
            ...prev,
            plotCode: plotId,
            plotName: plotLabel,
            cropName: crop.cropName || "",
            varietyName: crop.cropVariety || "",
            cropId: crop.cropId || "",
          }));
        }
      }
    );
  };

  const handleOwnerChange = (e) => {
    const owner = e.target.value;
    setOwnershipType(owner);
    const filteredVehicle = vehicleData?.filter(
      (itm) => itm.vmeOwnershipType === owner
    );
    setFilterdVehicleData(filteredVehicle || []);
  };

  useEffect(() => {
    getVehicleData();
    getHarvestOfficerData();
  }, []);

  const { sendRequest: postHarvestData } = useHttp();

  const submitHandler = (e) => {
    //  console.log(tableData);
    const Id = props.update
      ? props.update.vehicleWeighBridgeId
      : generateUniqueID();

    e.preventDefault();

    if (!vehicleNumber) {
      toast.error("Vehicle Number is required.");
      return;
    }
    if (!harvstDate) {
      toast.error("Harvest Date is required.");
      return;
    }
    if (!tripId) {
      toast.error("Trip Id is required.");
      return;
    }
    // if (!averageEmptyCratesWeightInKg) {
    //   toast.error("Average Empty Crates Weight is required.");
    //   return;
    // }
    // if (!loadedVehicleWeightTons) {
    //   toast.error("Loaded Vehicle Weight is required.");
    //   return;
    // }
    // if (!emptyVehicleWeightTons) {
    //   toast.error("Empty Vehicle Weight is required.");
    //   return;
    // }

    if (
      parseFloat(emptyVehicleWeightTons) > parseFloat(loadedVehicleWeightTons)
    ) {
      toast.error(
        "Empty Vehicle Weight (Tons) cannot be greater than Loaded Vehicle Weight (Tons)"
      );
      return;
    }

    if (
      parseFloat(averageEmptyCratesWeightInKg) >
      parseFloat(loadedVehicleWeightTons)
    ) {
      toast.error(
        "Average Empty Crates Weight (Kg) cannot be greater than Loaded Vehicle Weight (Tons)"
      );
      return;
    }

    console.log("tableData", tableData);

    const farmerHarvestDetail = tableData?.map((row) => ({
      vehicleWeighBridgeFarmerId: row.vehicleWeighBridgeFarmerId || 0,
      vehicleWeighBridgeId: parseInt(Id) || 0,
      cropId: row.cropId || 0,
      harvestId: row.harvestId || 0,
      fruitQuality: row.fruitQuality || "",
      cratesBagQtyLoaded: parseFloat(row.cratesBagQtyLoaded).toFixed(2) || 0,
      averageWeightOfCratesInKg:
        parseFloat(row.averageWeightOfCratesInKg).toFixed(2) || 0,
      totalQuantity: parseFloat(row.totalQuantity).toFixed(2) || 0,
      extraQty: parseFloat(row.extraQty).toFixed(2) || 0,

      isFarmershare: row.isFarmershare,
      farmerShareCratesBagQtyLoaded:
        parseFloat(row.farmerShareCratesBagQtyLoaded).toFixed(2) || 0,
      farmerShareAverageWeightOfCratesInKg:
        parseFloat(row.farmerShareAverageWeightOfCratesInKg).toFixed(2) || 0,
      farmerShareTotalQuantity:
        parseFloat(row.farmerShareTotalQuantity).toFixed(2) || 0,
      farmerShareExtraQty: parseFloat(row.farmerShareExtraQty).toFixed(2) || 0,
      grandTotal: parseFloat(row.grandTotal).toFixed(2) || 0,
      status: 1,
    }));

    if (farmerHarvestDetail.length === 0) {
      toast.error(
        "Please add at least one Farmer Harvest Detail before submitting."
      );
      return;
    }

    const payload = [
      {
        harvstDate: moment(harvstDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        vehicleWeighBridgeId: parseInt(Id),
        vehicleId: parseInt(vehicleNumber) || 0,
        tripId: parseInt(tripId) || 0,
        harvestOfficerId: parseInt(officerId) || 0,
        averageEmptyCratesWeightInKg:
          parseFloat(averageEmptyCratesWeightInKg).toFixed(2) || 0,
        loadedVehicleWeightTons:
          parseFloat(loadedVehicleWeightTons).toFixed(2) || 0,
        emptyVehicleWeightTons:
          parseFloat(emptyVehicleWeightTons).toFixed(2) || 0,
        // fileAttachment: attachments?.map((file) => ({
        //   urlAttachments: file,
        //   fileAttachments: file,
        //   entryLatLong,
        // })),

        fileAttachment: attachments?.map((file) => {
          const url = typeof file === "string" ? file : file.urlAttachments;

          return {
            urlAttachments: url,
            fileAttachments: url,
            entryLatLong: {
              latitude: parseFloat(entryLatLong.latitude) || 0,
              longitude: parseFloat(entryLatLong.longitude) || 0,
            },
          };
        }),

        // fileAttachment: attachments,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: parseInt(localStorage.getItem("orgId")),
        createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
        entryTime: moment().format("HH:mm:ss"),
        status: 1,
        entryLatLong,
        farmerHarvestDetail,
      },
    ];
    console.log("selectedCrop", selectedCrop);

    console.log("payload", payload);

    postHarvestData(
      {
        url: "/api/vehicleWeighBridge/",
        method: props.update ? "PUT" : "POST",
        body: payload,
      },
      (data) => {
        console.log(data);
        toast.success(
          `Farmer Harvest Details ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      }
    );
  };

  const { sendRequest: getDetailView } = useHttp();

  useEffect(() => {
    if (props.update) {
      const vehicleWeighBridgeId = props.update.vehicleWeighBridgeId;

      getDetailView(
        {
          url: `/api/vehicleWeighBridge/?orgId=${localStorage.getItem(
            "orgId"
          )}&vehicleWeighBridgeId=${vehicleWeighBridgeId}`,
        },
        (res) => {

          if (res.harvstDate) {
            setHarvstDate(
              moment(res.harvstDate, ["DD/MM/YYYY", "YYYY-MM-DD", moment.ISO_8601])
                .format("YYYY-MM-DD")
            );
          }



          setTripId(res.tripId);
          setAverageEmptyCratesWeightInKg(res.averageEmptyCratesWeightInKg);
          setLoadedVehicleWeightTons(res.loadedVehicleWeightTons);
          setEmptyVehicleWeightTons(res.emptyVehicleWeightTons);
          setAttachments(res.fileAttachment);
          setOfficerId(res.harvestOfficerId);
          setOwnershipType(res.ownershipType);
          setVehicleNumber(res.vehicleId);
          setTableData(res.farmerHarvestDetail);
        }
      );
    }
  }, [props.update]);


  const totalQtySum = tableData.reduce(
    (sum, row) => sum + (parseFloat(row.totalQuantity) || 0),
    0
  );

  useEffect(() => {
    const totalQtyTons = totalQtySum;
    const emptyTons = parseFloat(emptyVehicleWeightTons) || 0;
    const loaded = emptyTons + totalQtyTons;

    setLoadedVehicleWeightTons(loaded.toFixed(2));
  }, [emptyVehicleWeightTons, totalQtySum]);

  // const formatToDisplay = (isoDate) => {
  //   if (!isoDate) return "";
  //   return moment(isoDate, "YYYY-MM-DD").format("DD/MM/YYYY");
  // };

  // const formatToISO = (displayDate) => {
  //   if (!displayDate) return "";
  //   return moment(displayDate, "DD/MM/YYYY").format("YYYY-MM-DD");
  // };
  const hasTomatoCrop = tableData.some(
    (row) => row.cropName?.toLowerCase() === "tomato"
  );


  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              <div className="card card-default">
                <div className="card-header bg-info">
                  <h3 className="card-title"> Harvest Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Harvest Date</label>
                        <input
                          type="date"
                          required
                          className="form-control"
                          value={harvstDate || ""}
                          onChange={(e) => setHarvstDate(e.target.value)}
                        />


                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Harvest Officer</label>
                        <select
                          id="vehicleNumber"
                          className="form-control"
                          value={officerId}
                          onChange={(e) => setOfficerId(e.target.value)}
                          required
                        >
                          <option value="">Select</option>
                          {harvestOfficerData &&
                            harvestOfficerData?.map((x) => (
                              <option key={x.empId} value={x.empId}>
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Select Owner</label>
                        <select
                          id="ownership_type"
                          className="form-control"
                          required
                          onChange={handleOwnerChange}
                          value={ownershipType}
                        >
                          <option value="">Select</option>
                          <option value="Own">Own</option>
                          <option value="Rented">Rented</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Trip No</label>
                        <input
                          type="text"
                          id="trip_no"
                          required
                          className="form-control"
                          value={tripId}
                          onChange={(e) => setTripId(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Vehicle Number</label>
                        <select
                          id="vehicleNumber"
                          className="form-control"
                          value={vehicleNumber}
                          onChange={(e) => setVehicleNumber(e.target.value)}
                        >
                          <option value="">Select</option>
                          {filterdVehicleData &&
                            filterdVehicleData.map((x) => (
                              <option key={x.vmerId} value={x.vmerId}>
                                {x.vmeNo}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Add Harvest Details</label> <br />
                        <button
                          type="button"
                          id="product_details"
                          className="btn btn-sm btn-success"
                          onClick={handleShow}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    {hasTomatoCrop && (
                      <>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Empty Vehicle Weight(Ton)</label>
                            <input
                              type="number"
                              id="emptyVehicle"
                              required
                              className="form-control"
                              value={emptyVehicleWeightTons}
                              // onChange={(e) =>
                              //   setEmptyVehicleWeightTons(e.target.value)
                              // }
                              min="0"
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "" || parseFloat(val) >= 0) {
                                  setEmptyVehicleWeightTons(val);
                                }
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Loaded Vehicle Weight(Ton)</label>
                            <input
                              type="number"
                              className="form-control"
                              id="loadedVehicle"
                              required
                              value={loadedVehicleWeightTons}
                              // onChange={(e) =>
                              //   setLoadedVehicleWeightTons(e.target.value)
                              // }
                              min="0"
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "" || parseFloat(val) >= 0) {
                                  setLoadedVehicleWeightTons(val);
                                }
                              }}
                            />
                          </div>
                        </div>


                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Average Empty Crate Weight(kg)</label>
                            <input
                              type="number"
                              id="avg_emp_create"
                              required
                              className="form-control"
                              value={averageEmptyCratesWeightInKg}
                              // onChange={(e) =>
                              //   setAverageEmptyCratesWeightInKg(e.target.value)
                              // }
                              min="0"
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "" || parseFloat(val) >= 0) {
                                  setAverageEmptyCratesWeightInKg(val);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row">
                    <div className="form-group mb-3 mx-2">
                      <label>Attachments</label>
                      <div className="d-flex flex-wrap align-items-center">
                        {/* Upload Box */}
                        <label
                          htmlFor="fileUpload"
                          className="d-flex flex-column align-items-center justify-content-center border rounded"
                          style={{
                            width: "50px",
                            height: "50px",
                            cursor: "pointer",
                            borderStyle: "dashed",
                          }}
                        >
                          <i className="fas fa-camera fa-2x"></i>
                          <small>Upload</small>
                        </label>

                        <input
                          id="fileUpload"
                          type="file"
                          accept="image/*"
                          multiple
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />

                        {/* Preview Thumbnails */}
                      </div>
                      {attachments.map((file, index) => (
                        <>
                          <p className="mt-2 text-success">
                            <i className="fas fa-check-circle"></i>{" "}
                            {file.name || file.fileName} attached &nbsp;&nbsp;
                            <button
                              type="button"
                              className="btn"
                              onClick={() => handleRemoveFile(index)}
                            >
                              <i className="fas fa-times" />
                            </button>
                          </p>
                        </>
                      ))}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <button
                        className="btn btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>

      {show && (
        <Modal isOpen={true} style={modalStyles}>
          <div>
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                onClick={handleClose}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            {/* Body */}
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Farmer Name</label>
                    <AutoComplete
                      className="form-control"
                      style={{ height: "30px", width: "100%" }}
                      options={filteredFarmers}
                      placeholder="Farmer Name"
                      onSearch={handleSearch}
                      onSelect={handleSelect}
                      onChange={setInputValue}
                      value={inputValue}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Plot Code</label>
                    <select
                      className="form-control"
                      name="plotCode"
                      value={formData.plotCode}
                      onChange={handlePlotChange}
                      required
                    >
                      <option value="">Select</option>
                      {plotOptions.map((plot) => (
                        <option key={plot.value} value={plot.value}>
                          {plot.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Crop Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.cropName}
                      readOnly
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Variety Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.varietyName}
                      readOnly
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Harvest ID</label>
                    <input
                      type="number"
                      name="harvestId"
                      className="form-control"
                      value={formData.harvestId}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Fruit/Grain Quality</label>
                    <select
                      name="fruitQuality"
                      className="form-control"
                      value={formData.fruitQuality}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="Good">Good</option>
                      <option value="Bad">Bad</option>
                    </select>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Crates/Bags Qty Loaded</label>
                    <input
                      type="number"
                      className="form-control"
                      name="crates"
                      value={formData.crates}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">
                      Average Weight of Crate/Bags (kg)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="avgWeight"
                      value={formData.avgWeight}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Extra Crates/Bags (kg)</label>
                    <input
                      type="number"
                      className="form-control"
                      name="extraQty"
                      value={formData.extraQty}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Total Quantity (kg)</label>
                    <input
                      type="number"
                      className="form-control"
                      name="totalQty"
                      value={formatNumber(formData.totalQty)}
                      readOnly
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label text-primary">
                      Total Harvest Quantity (kg) – All Rows
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={formatNumber(totalQtySum)}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row">
                  {["maize", "soyabean", "soybean"].includes(
                    formData.cropName?.toLowerCase()
                  ) && (
                      <div className="col-md-12 mb-4 mt-2">
                        <div className="input-group mx-4">
                          <input
                            type="checkbox"
                            id="isFarmershare"
                            className="form-check-input"
                            checked={addFarmerShare}
                            onChange={(e) => setAddFarmerShare(e.target.checked)}
                          />
                          &nbsp;
                          <label htmlFor="isFarmershare">Add Farmer Share</label>
                        </div>
                      </div>
                    )}
                </div>

                <div className="row">
                  {addFarmerShare &&
                    ["maize", "soyabean", "soybean"].includes(
                      formData.cropName?.toLowerCase()
                    ) && (
                      <>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Crates/Bags Qty Loaded</label>
                          <input
                            type="number"
                            className="form-control"
                            name="farmerCrates"
                            value={formData.farmerCrates}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="form-label">
                            Average Weight of Crate/Bags (kg)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="farmerAvgWeight"
                            value={formData.farmerAvgWeight}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="form-label">Extra Crates/Bags (kg)</label>
                          <input
                            type="number"
                            className="form-control"
                            name="farmerExtraQty"
                            value={formData.farmerExtraQty}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="form-label">Total Quantity (kg)</label>
                          <input
                            type="number"
                            className="form-control"
                            name="farmerTotalQty"
                            value={formatNumber(formData.farmerTotalQty)}
                            readOnly
                          />
                        </div>
                      </>
                    )}

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Grand Total (kg)</label>
                    <input
                      type="number"
                      className="form-control"
                      name="grandTotalQty"
                      value={formatNumber(formData.grandTotalQty)}
                      readOnly
                    />
                  </div>

                  <div className="col-md-12 mb-3 text-center">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleAdd}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </form>

              <hr />

              {/* Table */}
              {/* {tableData?.length > 0 && (
                  <div className="table-responsive">
                    <table className="table table-bordered mt-3 table-responsive">
                      <thead>
                        <tr className="table-header text-center">
                          <th rowSpan="2">#</th>
                          <th rowSpan="2">Farmer</th>
                          <th rowSpan="2">Plot</th>
                          <th rowSpan="2">Crop</th>
                          <th rowSpan="2">Variety</th>
                          <th rowSpan="2">Fruit/Grain Quality</th>
                          <th rowSpan="2">Crates/Bags Qty Loaded</th>
                          <th rowSpan="2">Average Weight of Crate/Bags (kg)</th>
                          <th rowSpan="2">Extra Crates/Bags (kg)</th>
                          <th rowSpan="2">Total Quantity (kg)</th>

                      
                          <th colSpan="4">Farmer Share</th>

                          <th rowSpan="2">Grand Total</th>
                          <th rowSpan="2">Action</th>
                        </tr>

                        <tr className=" text-center">
                        
                          <th>Crates/Bags Qty Loaded</th>
                          <th>Avg Weight (kg)</th>
                          <th>Extra Qty (kg)</th>
                          <th>Total Qty (kg)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {tableData.map((row, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{row.farmerName}</td>
                            <td>{row.plotName || row.plotCode}</td>
                            <td>{row.cropName}</td>
                            <td>{row.varietyName}</td>
                            <td>{row.fruitQuality}</td>

                      
                            <td>{row.cratesBagQtyLoaded}</td>
                            <td>{row.averageWeightOfCratesInKg}</td>
                            <td>{row.extraQty}</td>
                            <td>{row.totalQuantity}</td>

                          
                            <td>{row.farmerShareCratesBagQtyLoaded}</td>
                            <td>{row.farmerShareAverageWeightOfCratesInKg}</td>
                            <td>{row.farmerShareExtraQty}</td>
                            <td>{row.farmerShareTotalQuantity}</td>

                            <td>{row.grandTotal}</td>

                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleDelete(i)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )} */}

              {tableData?.length > 0 && (
                <div className="table-responsive">
                  <table className="table table-bordered mt-3 table-responsive">
                    <thead>
                      <tr className="table-header text-center">
                        <th rowSpan="2">#</th>
                        <th rowSpan="2">Farmer</th>
                        <th rowSpan="2">Plot</th>
                        <th rowSpan="2">Crop</th>
                        <th rowSpan="2">Variety</th>
                        <th rowSpan="2">Fruit/Grain Quality</th>
                        <th rowSpan="2">Crates/Bags Qty Loaded</th>
                        <th rowSpan="2">Average Weight of Crate/Bags (kg)</th>
                        <th rowSpan="2">Extra Crates/Bags (kg)</th>
                        <th rowSpan="2">Total Quantity (kg)</th>

                        {/* Conditionally show Farmer Share group */}
                        {tableData.some((row) =>
                          ["maize", "soyabean", "soybean"].includes(
                            row.cropName?.toLowerCase()
                          )
                        ) && <th colSpan="4">Farmer Share</th>}

                        <th rowSpan="2">Grand Total</th>
                        <th rowSpan="2">Action</th>
                      </tr>

                      {/* Subheader row for Farmer Share */}
                      {tableData?.some((row) =>
                        ["maize", "soyabean", "soybean"].includes(
                          row.cropName?.toLowerCase()
                        )
                      ) && (
                          <tr className="text-center">
                            <th>Crates/Bags Qty Loaded</th>
                            <th>Avg Weight (kg)</th>
                            <th>Extra Qty (kg)</th>
                            <th>Total Qty (kg)</th>
                          </tr>
                        )}
                    </thead>

                    <tbody>
                      {tableData?.map((row, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{row.farmerName}</td>
                          <td>{row.plotName || row.plotCode}</td>
                          <td>{row.cropName}</td>
                          <td>{row.varietyName}</td>
                          <td>{row.fruitQuality}</td>

                          <td>{formatNumber(row.cratesBagQtyLoaded)}</td>
                          <td>{formatNumber(row.averageWeightOfCratesInKg)}</td>
                          <td>{formatNumber(row.extraQty)}</td>
                          <td>{formatNumber(row.totalQuantity)}</td>


                          {/* Conditionally show Farmer Share */}
                          {["maize", "soyabean", "soybean"].includes(
                            row.cropName?.toLowerCase()
                          ) && (
                              <>
                                <td>{formatNumber(row.farmerShareCratesBagQtyLoaded)}</td>
                                <td>{formatNumber(row.farmerShareAverageWeightOfCratesInKg)}</td>
                                <td>{formatNumber(row.farmerShareExtraQty)}</td>
                                <td>{formatNumber(row.farmerShareTotalQuantity)}</td>

                              </>
                            )}

                          <td>{formatNumber(row.grandTotal)}</td>


                          <td className="text-center">
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(i)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <div className="text-center mt-3">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleClose}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default HarvestDetailsForm;
